import React, { useEffect } from "react";
import Routes from "./Routes";
import { ToastProvider } from "./contexts/ToastContext";

function App() {
  useEffect(() => {
    // Initialize theme on app load
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
    
    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      document.documentElement?.classList?.add('dark');
    } else {
      document.documentElement?.classList?.remove('dark');
    }
  }, []);

  // Disable scroll and arrow key increment/decrement on all number inputs
  useEffect(() => {
    const handleWheel = (e) => {
      if (e.target?.type === 'number') {
        e.target.blur();
      }
    };

    const handleKeyDown = (e) => {
      if (e.target?.type === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
        e.preventDefault();
      }
    };

    document.addEventListener('wheel', handleWheel, { passive: true });
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('wheel', handleWheel);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <ToastProvider>
      <div className="min-h-screen bg-white text-foreground transition-colors duration-300">
        <Routes />
      </div>
    </ToastProvider>
  );
}

export default App;
